// Mock data for CFMPE - CAP Petite Enfance training center

export const siteInfo = {
  name: "CFMPE",
  tagline: "Centre de formation aux métiers de la Petite Enfance depuis 1996",
  address: "10 Avenue Georges Clemenceau, 06000 Nice",
  phone: "04.93.62.00.29",
  email: "institutcfmpe@gmail.com",
  since: 1996,
  aupresDesEnfantsDepuis: 1982,
};

export const stats = [
  { value: "99%", label: "Taux de réussite", detail: "session 2024" },
  { value: "91%", label: "Mentions obtenues", detail: "AB, B, TB" },
  { value: "19.36/20", label: "Major de promotion", detail: "note moyenne" },
  { value: "1996", label: "Année de fondation", detail: "29 ans d'expérience" },
];

export const formationDocuments = {
  rncp: "https://www.francecompetences.fr/recherche/rncp/28048/",
  programmeCap: "https://customer-assets-lxgj4vgw.emergentagent.net/job_formation-capp/artifacts/7bay2z82_PROGRAMME%20Version%202026%20V6.pdf",
  ficheCap: "https://customer-assets-lxgj4vgw.emergentagent.net/job_formation-capp/artifacts/muqpxh32_FICHE%20CAP%20AEPE%20VERSION%202025.pdf",
};

export const workplaces = [
  { icon: "Baby", label: "Crèches" },
  { icon: "Home", label: "Halte-garderies" },
  { icon: "Trees", label: "Centres de loisirs sans hébergement" },
  { icon: "Flower2", label: "Jardins d'enfants" },
  { icon: "HeartPulse", label: "Centres de santé spécialisés" },
  { icon: "House", label: "Accueil à domicile" },
];

export const softSkills = [
  "Capacité d'écoute",
  "Aptitude au dialogue",
  "Courtoisie",
  "Disponibilité",
  "Patience",
  "Sens de l'organisation",
  "Connaître les limites de ses compétences",
  "Communication et travail en équipe",
];

export const technicalSkills = [
  "Méthodes d'entretien des locaux et équipements",
  "Préparation et service des repas",
  "Soins d'hygiène corporelle et confort de l'enfant",
  "Prévention et sécurité",
  "Activités éducatives et de loisirs",
];

export const formationKeyInfo = [
  {
    icon: "GraduationCap",
    title: "Pré-requis",
    items: [
      "Niveau fin de 3ème minimum",
      "À partir de 17 ans (accord parental si mineur)",
      "Entretien préalable de motivation",
      "Test de positionnement obligatoire",
    ],
  },
  {
    icon: "Presentation",
    title: "Modalités pédagogiques",
    items: [
      "Parcours personnalisé selon les acquis",
      "Face-à-face avec la formatrice + supports",
      "Exercices progressifs, mises en situation",
      "Études de cas, simulations, débriefings",
    ],
  },
  {
    icon: "Wallet",
    title: "Tarifs",
    items: [
      "Tarif communiqué par email sur demande",
      "Écrivez à institutcfmpe@gmail.com",
      "Selon situation professionnelle et blocs à valider",
      "Dispenses possibles (voir arrêté du 23/06/2014)",
    ],
  },
  {
    icon: "Clock",
    title: "Délais d'accès",
    items: [
      "Variables selon les profils",
      "Selon l'organisme financeur",
      "Inscriptions ouvertes toute l'année",
      "Nous consulter pour la prochaine session",
    ],
  },
];

export const dispensations = {
  title: "Dispenses d'épreuves des domaines généraux et de l'EPS",
  subtitle: "Arrêté du 23 juin 2014",
  intro: "Si le candidat est titulaire d'un diplôme ci-dessous, il peut être dispensé des épreuves générales (Français, Histoire-Géographie, Enseignement moral et civique, Mathématiques, Sciences physiques et chimiques, EPS) :",
  diplomas: [
    "CAP (Éducation Nationale, maritime ou agricole)",
    "BEP (Éducation Nationale, maritime ou agricole)",
    "BAC, BP, BTS, DAEU ou examen spécial d'entrée à l'université",
    "Diplôme ou titre enregistré au moins de niveau 4 du RNCP",
    "Certification délivrée dans un État membre de l'UE, niveau 4 minimum",
  ],
  foreign: "Diplômes étrangers selon équivalence Française et accord du Rectorat.",
};

export const careerPaths = [
  {
    title: "Concours ATSEM",
    subtitle: "Agent Territorial Spécialisé des Écoles Maternelles",
    duration: "3 à 6 mois de préparation",
    level: "Fonction publique territoriale",
    highlights: [
      "CAP AEPE obligatoire pour le concours externe",
      "Nationalité française ou ressortissant UE",
      "Casier judiciaire vierge",
      "Débouché : École maternelle publique",
    ],
  },
  {
    title: "DEAP — Auxiliaire de Puériculture",
    subtitle: "Diplôme d'État",
    duration: "10 à 12 mois",
    level: "Niveau 4",
    highlights: [
      "Sélection sur dossier et entretien",
      "17 ans minimum",
      "Alternance cours / stages",
      "Débouchés : hôpital, maternité, PMI, crèche",
    ],
  },
  {
    title: "DEAES — Accompagnant Éducatif et Social",
    subtitle: "Ex Auxiliaire de Vie Sociale",
    duration: "12 à 18 mois",
    level: "Niveau 3",
    highlights: [
      "Dossier + entretien",
      "Spécialités : domicile, collectif, éducation inclusive",
      "Débouchés : aide à domicile, établissements spécialisés",
    ],
  },
  {
    title: "DEME — Moniteur Éducateur",
    subtitle: "Diplôme d'État",
    duration: "2 ans",
    level: "Niveau 4",
    highlights: [
      "Sélection dossier + entretien",
      "CAP AEPE apprécié",
      "Débouchés : IME, foyers, structures médico-sociales",
    ],
  },
  {
    title: "AMP — Aide Médico-Psychologique",
    subtitle: "Intégré au DEAES",
    duration: "12 à 18 mois",
    level: "Niveau 3",
    highlights: [
      "Dossier + entretien",
      "Public : personnes en situation de handicap / dépendance",
      "Débouchés : MAS, IME, EHPAD",
    ],
  },
  {
    title: "DEEJE — Éducateur de Jeunes Enfants",
    subtitle: "Diplôme d'État",
    duration: "3 ans",
    level: "Bac +3 (niveau 6)",
    highlights: [
      "Parcoursup ou sélection école spécialisée",
      "Bac ou équivalent requis",
      "Débouchés : crèches, structures petite enfance, direction adjointe",
    ],
  },
  {
    title: "Bac Pro ASSP",
    subtitle: "Accompagnement, Soins et Services à la Personne",
    duration: "2 ans après CAP",
    level: "Baccalauréat",
    highlights: [
      "Dossier scolaire",
      "Approfondissement soins et accompagnement",
      "Débouchés : concours infirmier, auxiliaire, aide-soignant",
    ],
  },
  {
    title: "Bac Pro SAPAT",
    subtitle: "Services aux Personnes et Animation dans les Territoires",
    duration: "2 ans après CAP",
    level: "Baccalauréat",
    highlights: [
      "Dossier scolaire",
      "Orientation rurale et animation territoriale",
      "Débouchés : structures sociales, animation, services à la personne",
    ],
  },
];

export const advantages = [
  {
    icon: "Award",
    title: "Diplôme d'État officiel",
    description: "CAP Accompagnant Éducatif Petite Enfance reconnu par le Ministère de l'Éducation Nationale.",
  },
  {
    icon: "FileCheck2",
    title: "Éligible au CPF",
    description: "Formation finançable via votre Compte Personnel de Formation (Mon Compte Formation).",
  },
  {
    icon: "Banknote",
    title: "Solutions de financement",
    description: "Multiples dispositifs : CPF, Pro-A, Transition Pro, Pole Emploi, financement personnel.",
  },
  {
    icon: "ShieldCheck",
    title: "Qualiopi certifié",
    description: "Certification qualité des processus des prestataires d'actions de développement des compétences.",
  },
];

export const formations = [
  {
    id: "cap-initiale",
    badge: "Formation initiale",
    title: "CAP AEPE — Formation initiale",
    subtitle: "Parcours complet en présentiel sur 9 mois",
    duration: "9 mois",
    rhythm: "32h / semaine",
    price: "Sur demande",
    highlights: [
      "Cours en présentiel dans nos locaux à Nice",
      "14 semaines de stage en structure petite enfance",
      "Préparation complète aux épreuves EP1, EP2, EP3",
      "Niveau 3ème requis, à partir de 17 ans",
    ],
  },
  {
    id: "cap-alternance",
    badge: "Alternance / Apprentissage",
    title: "CAP AEPE en apprentissage",
    subtitle: "Formez-vous tout en travaillant",
    duration: "10 à 11 mois",
    price: "Sur demande",
    highlights: [
      "Contrat d'apprentissage rémunéré en crèche ou école",
      "Prise en charge intégrale par l'OPCO",
      "Expérience professionnelle valorisée sur le CV",
      "Accompagnement dans la recherche d'entreprise",
    ],
  },
  {
    id: "cap-continue",
    badge: "Formation continue",
    title: "CAP AEPE — Adultes en reconversion",
    subtitle: "Rythme adapté aux salariés et demandeurs d'emploi",
    duration: "9 mois",
    price: "Éligible CPF",
    highlights: [
      "Financement CPF, Transition Pro, Pole Emploi",
      "Validation des acquis (VAE) possible",
    ],
  },
  {
    id: "cap-vae",
    badge: "VAE",
    title: "Validation des Acquis de l'Expérience",
    subtitle: "Faire reconnaître votre expérience de terrain",
    duration: "Variable",
    price: "Sur demande",
    highlights: [
      "Accompagnement à la rédaction du livret 2",
      "Préparation à l'entretien avec le jury",
      "Éligible au CPF et Transitions Pro",
      "Idéal pour les professionnels en poste",
    ],
  },
  {
    id: "cap-elearning",
    badge: "E-learning",
    title: "CAP AEPE 100% en ligne",
    subtitle: "Formez-vous à votre rythme, depuis chez vous",
    duration: "Rythme individualisé",
    price: "Sur demande",
    highlights: [
      "Plateforme e-learning accessible 24h/24",
      "Cours vidéo, quiz interactifs et supports téléchargeables",
      "Tutorat individuel et classes virtuelles en direct",
      "Accompagnement à la recherche de stages",
    ],
  },
  {
    id: "cap-blended",
    badge: "Blended learning",
    title: "CAP AEPE — Formation mixte",
    subtitle: "Le meilleur du présentiel et du distanciel",
    duration: "10 mois",
    price: "Sur demande",
    highlights: [
      "Alternance présentiel à Nice et cours à distance",
      "Regroupements mensuels en petits groupes",
      "Suivi personnalisé sur plateforme dédiée",
      "Flexibilité idéale pour concilier vie pro / perso",
    ],
  },
];

export const programModules = [
  {
    code: "EP1",
    title: "Accompagner le développement du jeune enfant",
    topics: [
      "Soins quotidiens et hygiène",
      "Accompagnement à l'acquisition de l'autonomie",
      "Développement psychomoteur et affectif",
      "Activités d'éveil et jeux",
    ],
  },
  {
    code: "EP2",
    title: "Exercer son activité en accueil collectif",
    topics: [
      "Travail en équipe pluridisciplinaire",
      "Projet d'accueil personnalisé",
      "Conception et animation d'activités",
      "Communication avec les familles",
    ],
  },
  {
    code: "EP3",
    title: "Exercer son activité en accueil individuel",
    topics: [
      "Organisation de l'accueil au domicile",
      "Gestion des repas et menus adaptés",
      "Sécurité et prévention des risques",
      "Réglementation et contractualisation",
    ],
  },
];

export const financements = [
  {
    title: "CPF — Mon Compte Formation",
    description: "Utilisez vos droits acquis tout au long de votre vie active. Notre formation CAP AEPE est entièrement éligible.",
    tag: "Le plus utilisé",
  },
  {
    title: "Contrat d'apprentissage",
    description: "Formation 100% prise en charge par l'OPCO. Vous êtes rémunéré pendant toute la durée de votre apprentissage.",
    tag: "Gratuit",
  },
  {
    title: "Pole Emploi — AIF",
    description: "L'Aide Individuelle à la Formation permet aux demandeurs d'emploi de financer tout ou partie de leur cursus.",
    tag: "Demandeur d'emploi",
  },
  {
    title: "Transitions Pro",
    description: "Ancien CPF de Transition. Idéal pour les salariés souhaitant se reconvertir vers les métiers de la petite enfance.",
    tag: "Reconversion",
  },
  {
    title: "Financement personnel",
    description: "Possibilité de paiement en 10 fois sans frais. Devis personnalisé sur simple demande.",
    tag: "Souple",
  },
  {
    title: "Pro-A / Plan de développement",
    description: "Pour les salariés déjà en poste souhaitant faire reconnaître leurs compétences par un diplôme d'État.",
    tag: "Salariés",
  },
];

export const testimonials = [
  {
    id: 1,
    name: "Soad A.",
    role: "Promotion 2024",
    content: "Très satisfaite de ma formation au CFMPE. Point fort : l'écoute et la patience de l'équipe pédagogique ainsi que leur implication constante.",
    rating: 5,
  },
  {
    id: 2,
    name: "Marie L.",
    role: "Auxiliaire de crèche",
    content: "Une formation complète, des formateurs passionnés et un vrai suivi individuel. J'ai obtenu mon CAP AEPE avec mention Bien !",
    rating: 5,
  },
  {
    id: 3,
    name: "Karim B.",
    role: "Reconversion professionnelle",
    content: "Après 15 ans dans le bâtiment, je me suis reconverti grâce au CFMPE. Équipe bienveillante, méthode claire, résultat au rendez-vous.",
    rating: 5,
  },
  {
    id: 4,
    name: "Sophie R.",
    role: "Assistante maternelle",
    content: "Les groupes réduits font toute la différence. On progresse vite, on est écouté et l'ambiance est chaleureuse. Je recommande !",
    rating: 5,
  },
  {
    id: 5,
    name: "Jennifer P.",
    role: "Promotion 2023",
    content: "Un centre de formation à taille humaine avec une véritable expertise. Les stages sont bien encadrés et le réseau est précieux.",
    rating: 5,
  },
];

export const faqs = [
  {
    question: "Quelles sont les conditions d'admission au CAP AEPE ?",
    answer: "Le CAP AEPE est accessible à partir de 16 ans, sans diplôme préalable exigé pour la formation initiale. Un entretien de motivation et un test de positionnement permettent d'évaluer votre projet.",
  },
  {
    question: "Combien de temps dure la formation ?",
    answer: "La formation initiale s'étend sur 10 mois environ (de septembre à juin), avec 14 semaines de stage. En alternance, le parcours peut aller jusqu'à 24 mois.",
  },
  {
    question: "Quels métiers après le CAP AEPE ?",
    answer: "Assistant(e) maternel(le), auxiliaire de crèche, agent territorial des écoles maternelles (ATSEM après concours), animateur(trice) petite enfance, garde d'enfants à domicile.",
  },
  {
    question: "La formation est-elle finançable par le CPF ?",
    answer: "Oui, notre formation CAP AEPE est entièrement éligible au CPF. Nous vous accompagnons dans le montage de votre dossier sur Mon Compte Formation.",
  },
  {
    question: "Puis-je passer uniquement les épreuves professionnelles ?",
    answer: "Oui, si vous êtes déjà titulaire d'un diplôme de niveau CAP ou supérieur, vous êtes dispensé(e) des matières générales et ne présentez que les épreuves EP1, EP2, EP3.",
  },
  {
    question: "Le centre propose-t-il de l'accompagnement pour trouver un stage ?",
    answer: "Absolument. Notre réseau de partenaires (crèches, écoles maternelles, structures d'accueil) et notre équipe pédagogique vous aident à trouver vos terrains de stage.",
  },
];

export const partners = [
  "Qualiopi",
  "Rectorat de Nice",
  "Mon Compte Formation",
  "Pole Emploi",
  "OPCO EP",
  "Transitions Pro",
  "ABC E-learning",
];

export const brandLogos = {
  cfmpe: "https://customer-assets-lxgj4vgw.emergentagent.net/job_formation-capp/artifacts/oe65ny3y_LOGO%20BONHOMME%20SANS%20CONTOURS.webp",
  qualiopi: "https://customer-assets-lxgj4vgw.emergentagent.net/job_formation-capp/artifacts/8w528588_logo%20qualiopi%202021.webp",
};

export const heroImages = {
  main: "https://customer-assets-lxgj4vgw.emergentagent.net/job_formation-capp/artifacts/lgiahi4h_IMG_4154.jpeg",
  teaching: "https://customer-assets-lxgj4vgw.emergentagent.net/job_formation-capp/artifacts/lgiahi4h_IMG_4154.jpeg",
  classroom: "https://customer-assets-lxgj4vgw.emergentagent.net/job_formation-capp/artifacts/kl2x13f1_IMG_3123.webp",
  toddler: "https://customer-assets-lxgj4vgw.emergentagent.net/job_formation-capp/artifacts/rs20jw1w_71c929ca-d33c-464d-9838-322b836898e8.JPG",
  art: "https://customer-assets-lxgj4vgw.emergentagent.net/job_formation-capp/artifacts/rs20jw1w_71c929ca-d33c-464d-9838-322b836898e8.JPG",
  drawing: "https://customer-assets-lxgj4vgw.emergentagent.net/job_formation-capp/artifacts/acngb0e9_IMG_0611.webp",
  play: "https://customer-assets-lxgj4vgw.emergentagent.net/job_formation-capp/artifacts/654m0y9e_IMG_0013.webp",
  blocks: "https://customer-assets-lxgj4vgw.emergentagent.net/job_formation-capp/artifacts/654m0y9e_IMG_0013.webp",
};
